<template>
  <div>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1429 5.00007V3.5715C12.1429 3.19262 11.9924 2.82925 11.7245 2.56135C11.4566 2.29344 11.0932 2.14293 10.7144 2.14293H9.28578M5.71436 15.0001H2.14293C1.76405 15.0001 1.40068 14.8496 1.13277 14.5817C0.864865 14.3137 0.714355 13.9504 0.714355 13.5715V3.5715C0.714355 3.19262 0.864865 2.82925 1.13277 2.56135C1.40068 2.29344 1.76405 2.14293 2.14293 2.14293H3.5715M12.1429 12.1429H16.4286M12.1429 15.0001H16.4286M17.8572 7.85721H10.7144C10.3355 7.85721 9.97211 8.00772 9.7042 8.27563C9.43629 8.54354 9.28578 8.9069 9.28578 9.28578V17.8572C9.28578 18.2361 9.43629 18.5995 9.7042 18.8674C9.97211 19.1353 10.3355 19.2858 10.7144 19.2858H17.8572C18.2361 19.2858 18.5995 19.1353 18.8674 18.8674C19.1353 18.5995 19.2858 18.2361 19.2858 17.8572V9.28578C19.2858 8.9069 19.1353 8.54354 18.8674 8.27563C18.5995 8.00772 18.2361 7.85721 17.8572 7.85721ZM9.64293 0.714355H3.21436L3.80007 3.02864C3.83575 3.18354 3.92309 3.32168 4.04771 3.42034C4.17234 3.519 4.32683 3.57231 4.48578 3.5715H8.3715C8.53045 3.57231 8.68494 3.519 8.80957 3.42034C8.9342 3.32168 9.02153 3.18354 9.05721 3.02864L9.64293 0.714355Z"
        stroke="#00A482"
        stroke-width="1.42857"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PasteFromClipboard',
};
</script>
